<template>
  <form-builder-editor-field
    :item="item"
    :show-required="true"
    :show-hide-in-form="true"
    :show-hide-in-reports="true"
    :show-hide-in-preview="true"
    :show-share-with-participant="true"
    :show-is-shared="true"
    v-on="$listeners"
  >
    <template slot="header">
      <editor-checkbox v-model="item.multiple"
                       label="Multiple"
                       :id="item.name + '_multiple'"/>
    </template>
  </form-builder-editor-field>
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";
import EditorCheckbox from "./EditorCheckbox";

export default {
  components: {FormBuilderEditorField, EditorCheckbox},

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  setup() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// FormBuilderEditorFile.vue?a57a0ca2